import { createApp } from "vue";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "vuetify/styles";

import App from "./App.vue";
import router from "./router";
import "./assets/bhmlf-theme.css";
import reveal from "./directives/reveal";

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "bhmlf",
    themes: {
      bhmlf: {
        dark: false,
        colors: {
          primary: "#C17A2F",
          secondary: "#1E3A2F",
          accent: "#2F6B52",
          surface: "#FFFFFF",
          background: "#F3F5F2",
          error: "#B00020",
          info: "#243447",
          success: "#2F6B52",
          warning: "#C17A2F",
          "on-primary": "#FFFFFF",
          "on-secondary": "#FFFFFF",
          "on-accent": "#FFFFFF",
          "on-success": "#FFFFFF",
          "on-info": "#FFFFFF",
          "on-warning": "#FFFFFF",
          "on-error": "#FFFFFF",
        },
      },
    },
  },
  defaults: {
    VBtn: {
      rounded: "md",
      style: "text-transform: none; letter-spacing: 0.01em; font-weight: 600;",
    },
  },
});

createApp(App).directive("reveal", reveal).use(router).use(vuetify).mount("#app");
